import { createAsyncThunk } from '@reduxjs/toolkit';
import ringCentralApi from '~/apis/ring-central';
import { GET_RING_CENTRAL, UPDATE_RING_CENTRAL } from '~/utils/constants/actionType';
import { IRingCentral } from '~/utils/interface/ring-central';

export const handleGetRingCentral = createAsyncThunk<IRingCentral>(
  GET_RING_CENTRAL,
  async (_params, { rejectWithValue }) => {
    try {
      const res = await ringCentralApi.getRingCentral();
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleUpdateRingCentral = createAsyncThunk<IRingCentral, IRingCentral>(
  UPDATE_RING_CENTRAL,
  async (data: IRingCentral, { rejectWithValue }) => {
    try {
      const res = await ringCentralApi.updateRingCentral(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
